import { CheckCircle2, X } from "lucide-react";
import { useState, type FormEvent } from "react";
import { formatPrice, houseModels } from "../data";
import { calculatePrice } from "../pricing";
import { useConfiguratorStore } from "../store";

export function QuoteModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const configuration = useConfiguratorStore((state) => state.configuration);
  const [submitted, setSubmitted] = useState(false);
  const price = calculatePrice(configuration);
  const model = houseModels.find((item) => item.id === configuration.modelId);

  if (!open) return null;

  const submit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={onClose}>
      <section className="quote-modal" role="dialog" aria-modal="true" aria-labelledby="quote-title" onMouseDown={(event) => event.stopPropagation()}>
        <button className="modal-close" type="button" onClick={onClose} aria-label="Luk"><X size={20} /></button>
        {submitted ? (
          <div className="quote-success">
            <CheckCircle2 size={42} />
            <h2>Tak for din forespørgsel</h2>
            <p>En CBCISO byggerådgiver vender tilbage og tager udgangspunkt i din gemte konfiguration.</p>
            <button className="button button-primary" type="button" onClick={onClose}>Tilbage til huset</button>
          </div>
        ) : (
          <>
            <div className="quote-modal-heading">
              <span>Uforpligtende tilbud</span>
              <h2 id="quote-title">Lad os bygge videre</h2>
              <p>Fortæl hvor huset skal stå. Vi kontakter dig med næste skridt.</p>
            </div>
            <div className="quote-summary">
              <span>{model?.name} · {configuration.areaM2} m²</span>
              <strong>{formatPrice(price.total)}</strong>
            </div>
            <form onSubmit={submit}>
              <label>Navn<input name="name" required autoComplete="name" /></label>
              <div className="form-row">
                <label>E-mail<input name="email" type="email" required autoComplete="email" /></label>
                <label>Telefon<input name="phone" type="tel" required autoComplete="tel" /></label>
              </div>
              <div className="form-row">
                <label>Postnummer<input name="postalCode" inputMode="numeric" required /></label>
                <label>Forventet byggestart
                  <select name="start">
                    <option>Inden for 6 måneder</option>
                    <option>6–12 måneder</option>
                    <option>1–2 år</option>
                    <option>Ikke besluttet</option>
                  </select>
                </label>
              </div>
              <label>Ønsket byggested<input name="location" placeholder="By eller adresse" /></label>
              <label>Besked<textarea name="message" rows={3} placeholder="Er der noget, vi skal vide?" /></label>
              <label className="consent">
                <input type="checkbox" required />
                <span>Jeg accepterer, at CBCISO kontakter mig om denne forespørgsel.</span>
              </label>
              <input type="hidden" name="configuration" value={JSON.stringify(configuration)} />
              <button className="button button-primary full-width" type="submit">Send forespørgsel</button>
            </form>
          </>
        )}
      </section>
    </div>
  );
}
